module.exports = __webpack_public_path__ + "static/x43-010a0eda2495e96cac4158ea52f0f7aa.png";